import { Logger } from "shared/lib/Logger"
import { InvalidDataError } from "shared/types/error/InvalidDataError"

export const ROOM_NUMBER_FALLBACK = "0"

// Last guard before a room is sent: the API rejects rooms without a number,
// which legacy rooms can still lack. Reported so the data can be fixed.
export function getRoomNumberFallback(
  room: { id?: string | null; number?: string | null },
  source: string
): string {
  const number = room.number?.trim()
  if (number) return number

  Logger.error(
    new InvalidDataError(`Room without number sent as "0" (${source})`, {
      data: { id: room.id }
    })
  )
  return ROOM_NUMBER_FALLBACK
}
